import $ from "jquery"

/**
 * Created by filatov on 03.02.2016.
 */

export default function BaseFieldsDrawerController(){}

BaseFieldsDrawerController.prototype.init = function(config){
    this.getElementByIdFunction = config.getElementByIdFunction;
    this.drawers = [];
    return this;
};

BaseFieldsDrawerController.prototype.initFields = function(accountSettings){
    for(var i = 0; i < this.drawers.length; ++i){
       this.drawers[i].initFields(accountSettings);
    }
};

BaseFieldsDrawerController.prototype.setErrorState = function() {}

BaseFieldsDrawerController.prototype.addDrawer = function(drawer){
    this.drawers.push(drawer);
};

BaseFieldsDrawerController.prototype.getSpecificValues = function(){
    var values = {};
    for(var i = 0; i < this.drawers.length; ++i){
        $.extend(values,this.drawers[i].getObjectValues());
    }
    return values;
};

BaseFieldsDrawerController.prototype.validateFields = function(oldErrors){
    var errors = {};
    for(var i = 0; i < this.drawers.length; ++i){
        $.extend(errors, this.drawers[i].validateFields(oldErrors));
    }
    return errors;
};

BaseFieldsDrawerController.prototype.getErrors = function(){
    var errors = {};
    for(var i = 0; i < this.drawers.length; ++i){
        $.extend(errors, this.drawers[i].getErrors());
    }
    return errors;
};

BaseFieldsDrawerController.prototype.getNotCopyValues = function(){
};

BaseFieldsDrawerController.prototype.updateAccountSettings = function(accountSettings) {
}



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/BaseFieldsDrawerController.js